// extracted by mini-css-extract-plugin
export var cardReview = "gk_Mj";
export var textUsername = "gk_Nj";
export var textReview = "gk_Pj";
export var linkTweet = "gk_Qj";
export var img = "gk_Rj";